import React from "react";
import { Modal, Button } from "react-bootstrap";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] Caught error:", error, info);
  }

  // Reset when the route changes so navigating away clears the error
  componentDidUpdate(prevProps) {
    if (
      this.state.hasError &&
      prevProps.locationKey !== this.props.locationKey
    ) {
      this.setState({ hasError: false, error: null });
    }
  }

  handleDismiss = () => {
    this.setState({ hasError: false, error: null });
    if (this.props.onDismiss) {
      this.props.onDismiss();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <>
          {this.props.children}
          <Modal show centered onHide={this.handleDismiss}>
            <Modal.Header closeButton>
              <Modal.Title>Something went wrong</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>
                An unexpected error occurred. Please try again or go back to
                the previous page.
              </p>
              {this.state.error && (
                <small className="text-muted">
                  {this.state.error.message}
                </small>
              )}
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => window.history.back()}>
                Go Back
              </Button>
              <Button variant="primary" onClick={this.handleDismiss}>
                Dismiss
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
